export class StockLevelDailyClosedDateDto {
  countedDateTime: Date;
  countedDate: string;
  beforeTrading: boolean;
  countStockCategoryId: number;
  stockCategoryIdList: string;
}
